/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-return-await */
import fetch from '../../fetch';
import { IHttpMethod, ServicesURL } from '../../../ts/enums/fetch-enums';

const endpoints = {
  registerUser: 'Autenticacao/Registrar',
  registerUserCode: 'Autenticacao/send-confirmation-code',
  loginEmailPassword: 'Autenticacao/Login',
  loginGoogle: 'Autenticacao/oauth/google',
  loginApple: 'Autenticacao/oauth/apple',
  forgotPassword: 'Autenticacao/SolicitarRecuperacaoDeSenha',
  validateForgotPasswordToken: 'Autenticacao/ValidarTokenDeRecuperacao',
  registerNewPassword: 'Autenticacao/RecuperarSenha',
  getUserData: 'MeusDados/Carregar',
  deleteUserData: 'MeusDados',
  getUserPayments: 'MeusDados/payments',
  updateUserParams: 'UserParams',
  updateUserData: 'MeusDados/Alterar',
  updateUserName: 'MeusDados/AlterarNome',
};

export interface IRegisterUser {
  email: string;
  nome: string;
  senha: string;
  celular: string;
  emailCode: string;
}

export async function getUserData(token?: string) {
  const { data } = await fetch({
    method: IHttpMethod.GET,
    path: `${endpoints.getUserData}`,
    service: ServicesURL.CRYPTOCRONTROL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data;
}

interface IdeleteUserData {
  password: string;
}

export async function deleteUserData(data: IdeleteUserData) {
  await fetch({
    method: IHttpMethod.DELETE,
    path: `${endpoints.deleteUserData}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data,
  });
}

interface IupdateUserData {
  nome?: string;
  telefone?: string;
  acceptSMS?: boolean;
}

export async function updateUserData(userData?: IupdateUserData) {
  const { data } = await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.updateUserData}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data: userData,
  });

  return data;
}

export async function updateUserName(nome: string) {
  const { data } = await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.updateUserName}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data: { nome },
  });

  return data;
}

export async function getUserPayments() {
  const { data } = await fetch({
    method: IHttpMethod.GET,
    path: `${endpoints.getUserPayments}`,
    service: ServicesURL.CRYPTOCRONTROL,
  });

  return data;
}

export async function registerUser(data: IRegisterUser) {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.registerUser}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data,
  });
}

export interface IRegisterUserCode {
  email: string;
}

export async function registerUserCode(data: IRegisterUserCode) {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.registerUserCode}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data,
  });
}

export interface ILoginEmailPassword {
  login: string;
  senha: string;
  pushToken?: string;
  pushTokenOS?: string;
}

export async function loginEmailPassword(data: ILoginEmailPassword) {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.loginEmailPassword}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data,
  });
}

interface ILoginGoogleResponse {
  redirectUrl: string;
}

export async function loginGoogle(): Promise<ILoginGoogleResponse> {
  const { data } = await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.loginGoogle}`,
    service: ServicesURL.CRYPTOCRONTROL,
  });

  return data;
}

interface ILoginAppleResponse {
  redirectUrl: string;
}

export async function loginApple(): Promise<ILoginAppleResponse> {
  const { data } = await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.loginApple}`,
    service: ServicesURL.CRYPTOCRONTROL,
  });

  return data;
}

export interface IForgotPassword {
  email: string;
}

export async function forgotPassword(data: IForgotPassword) {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.forgotPassword}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data,
  });
}

export interface IValidateForgotPasswordToken {
  token: string;
}

export async function validateForgotPasswordToken(
  data: IValidateForgotPasswordToken
) {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.validateForgotPasswordToken}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data,
  });
}

export interface IRegisterNewPassword {
  token: string;
  senha: string;
}

export async function registerNewPassword(data: IRegisterNewPassword) {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${endpoints.registerNewPassword}`,
    service: ServicesURL.CRYPTOCRONTROL,
    data,
  });
}

export async function setUserParam(
  field: string,
  value: string | number | boolean
): Promise<void> {
  await fetch({
    method: IHttpMethod.PATCH,
    path: endpoints.updateUserParams,
    data: { [field]: value },
    service: ServicesURL.CRYPTOCRONTROL,
  });
}
